import { FC, useMemo } from 'react';

import SidebarTabs from 'components/SidebarTabs/SidebarTabs';

import { SidebarTabsItem } from 'types/sidebar';

import { JobseekerAttachmentTypes } from 'constants/enums';
import { FALLBACK_NUMBER_VALUE } from 'constants/uiSettings';

import { useTranslation } from 'react-i18next';
import JobseekerDocumentsView from '../JobseekerDocumentsView/JobseekerDocumentsView';
import JobseekerView from '../JobseekerView/JobseekerView';
import useGetJobseeker from '../hooks/useGetJobseeker';

export const JOBSEEKER_SIDEBAR_ITEMS_IDS = {
  JOBSEEKER: 1,
  DOCUMENTS: 2
};

const JOBSEEKER_ATTACHMENT_TYPES_TO_DISPLAY_IN_DOCUMENTS = [
  JobseekerAttachmentTypes.CV,
  JobseekerAttachmentTypes.OfferLetter
];

const JobseekerSidebar: FC = () => {
  const { t } = useTranslation()
  const { jobseeker, isLoading, fetchJobseekerData } = useGetJobseeker();

  const attachmentsToDisplayQuantity =
    jobseeker?.attachments
      ?.map((el) => el.type)
      ?.filter((el) =>
        JOBSEEKER_ATTACHMENT_TYPES_TO_DISPLAY_IN_DOCUMENTS.includes(el)
      )?.length || FALLBACK_NUMBER_VALUE;

  const items: SidebarTabsItem[] = useMemo(
    () => [
      {
        id: JOBSEEKER_SIDEBAR_ITEMS_IDS.JOBSEEKER,
        title: t('sidebar.jobseeker.tabs.jobseeker'),
        component: <JobseekerView />
      },
      {
        id: JOBSEEKER_SIDEBAR_ITEMS_IDS.DOCUMENTS,
        title: t('sidebar.jobseeker.tabs.documents', { amount: attachmentsToDisplayQuantity }),
        component: (
          <JobseekerDocumentsView
            isLoading={isLoading}
            fetchJobseekerData={fetchJobseekerData}
          />
        )
      }
    ],
    [isLoading, jobseeker, fetchJobseekerData]
  );

  return (
    <div>
      <SidebarTabs items={items} isChangeCurrentTabOnNewItems={false} />
    </div>
  );
};

export default JobseekerSidebar;
